import React from 'react';

import { Switch } from 'react-router-dom';

import { ScrollToTop } from './ScrollToTop';
import { SuspenseRoute } from 'components/shared/SuspenseRoute/SuspenseRoute';
import { RegisterLanding } from 'components/RegisterLanding/RegisterLanding';
import { Registration } from 'components/Registration/Registration';
import { CreateWorkerSuccess } from 'components/CreateWorker/CreateWorkerSuccess';
import { LoadingPage } from 'components/LoadingPage/LoadingPage';
import { CheckoutRoute } from 'components/Main/Routes/CheckoutRoute';
import { LoginLanding } from 'components/LoginLanding/LoginLanding';

export const Main = () => (
    <div className="position-relative vh-100 d-flex flex-column">
        <ScrollToTop>
            <Switch>
                <SuspenseRoute path="/" exact>
                    <RegisterLanding/>
                </SuspenseRoute>
                <SuspenseRoute path="/login" exact>
                    <LoginLanding/>
                </SuspenseRoute>
                <SuspenseRoute path="/register" exact>
                    <Registration/>
                </SuspenseRoute>
                <SuspenseRoute path="/registration-successful" exact>
                    <CreateWorkerSuccess/>
                </SuspenseRoute>
                <SuspenseRoute path="/payment" exact>
                    <CheckoutRoute/>
                </SuspenseRoute>
            </Switch>
        </ScrollToTop>
        <LoadingPage/>
    </div>
);
